const theme = {
    colors:{
        padrao:'#f5f5f5',
        dark:'#404e4d',
        text:'#5bc0eb',
        button:'#fde74c',
        bhover:'#feee7e',
        input:'#ccc',
    },
    fonts:{
        regular:'Monteserrat,sans-serif',
    }
}

export default theme;
/* 

outros cores -> #c3423f #9bc53d #fde74c;

*/